/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { ifaApprovalPostRequestSchema } from './ifaApprovalPostRequestSchema.ts';
import { ifaApprovalPostResponseSchema } from './ifaApprovalPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postIfaApproval200Schema = z.lazy(() => ifaApprovalPostResponseSchema);

/**
 * @description 505 response
 */
export const postIfaApproval505Schema = z.any();

export const postIfaApprovalMutationRequestSchema = z.lazy(() => ifaApprovalPostRequestSchema);

export const postIfaApprovalMutationResponseSchema = z.lazy(() => postIfaApproval200Schema);
